const features = [
  {
    icon: 'ri-shield-check-line',
    title: '官方正版认证',
    description: 'PG国际下载008提供官方正版安装包，通过多重安全检测，确保文件无病毒、无恶意插件，保护您的设备安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速下载体验',
    description: '采用全球CDN加速节点，无论您身在何处都能享受极速下载体验，安装包体积优化，节省流量。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台兼容',
    description: '全面支持iOS与Android系统，适配各种设备型号。PC端可通过模拟器运行，随时随地畅享游戏。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '24小时客服',
    description: 'PG国际008提供全天候在线客服支持，专业团队随时为您解答下载、安装、使用中的任何疑问。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '隐私安全保障',
    description: '采用银行级数据加密技术，严格保护您的个人信息与交易数据，让您放心畅玩PG国际平台。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续版本更新',
    description: 'PG国际008团队持续优化产品体验，定期推出新版本，提供最新游戏内容和功能升级，始终保持领先。',
  },
];

export default function HomeFeatures() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择 PG国际下载008
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            我们致力于为全球玩家提供最优质的PG国际平台下载服务，以下是我们与众不同的六大理由
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}